import React, { useEffect, useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { getApiCallState } from "../Models";
import { useDispatch } from "react-redux";
import { fakePayment } from "../Actions";
import { SpinnerSmall } from "../../Shared/Components/Spinner";
import { getErrorMessages } from "../Shared/Utils";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { getSettings } from "../Settings";
import { Price } from "../Components/Price";

const strings = getStrings().component.payment;

export const FakePaymentDialog = (props: { show: boolean, bookingNumber: string, amount: number, isPaid?: boolean, onCancel: () => void; }) => {

	const dispatch = useDispatch();
	const [paymentreference, setPaymentreference] = useState("test");

	const apicalls = getApiCallState();
	const paymentState = apicalls.getLoadingState("fakePayment");

	const pay = () => {
		dispatch(fakePayment(props.bookingNumber, paymentreference));
	};

	const cancel = () => {
		props.onCancel();
	};

	useEffect(() => {
		const settings = getSettings();
		if (paymentState === "loaded")
		{
			const url = `${settings.receiptUrl}?bookingNumber=${props.bookingNumber}&paymentReference=${paymentreference}`;
			setTimeout(() => {
				window.location.assign(url);
			}, 1000);
		}
		if (paymentState === "error")
		{
			const status = apicalls.getStatus("fakePayment");
			if (status === 402) { //Payment Required
				const url = `${settings.paymentFailedUrl}?bookingNumber=${props.bookingNumber}&status=declined`;
				window.location.assign(url);
			}
		}
	}, [paymentState]);

	return <Modal show={props.show} centered backdrop="static" onClose={cancel} onHide={cancel}>
		<Modal.Header><Modal.Title>Fejkbetalning</Modal.Title></Modal.Header>
		<Modal.Body>
			<p>Om du låtsas betala så låtsas vi att köra ett tåg.</p>
			<dl>
				<dt>Bokning</dt>
				<dd>{props.bookingNumber}</dd>
				<dt>Belopp att betala</dt>
				<dd><Price amount={props.amount} showFractions /></dd>
				<dt>Betalningsreferens</dt>
				<dd><input type="text" value={paymentreference} onChange={e => setPaymentreference(e.target.value)} /></dd>
			</dl>

			<Alert variant="success" show={paymentState==="loaded"}>
				<strong>Betalning genomförd!</strong><br />
				Bokningen är markerad som betald och bekräftad. Vänta så skickas du vidare till kvittosidan...
			</Alert>
			<Alert variant="danger" show={paymentState==="error"}>
				<strong>Fel!</strong><br />
				Det gick inte att sätta bokningen som betald och bekräftad. Något blev fel.
				<ul>{getErrorMessages("fakePayment", apicalls)?.map((x, idx) => <li key={idx}>{x}</li>)}</ul>
			</Alert>

		</Modal.Body>
		{ !props.isPaid && paymentState !== "loaded" &&
		<Modal.Footer>
			<Button variant="outline-secondary" onClick={cancel}>{strings.cancel}</Button>
			<Button variant="primary" disabled={paymentState === "loading"} onClick={pay}>Betala <Price amount={props.amount} showFractions /> {paymentState === "loading" && <SpinnerSmall />}</Button>
		</Modal.Footer>}

	</Modal>;
};